<template>
  <div>
    <courses-progress />
    <b-card title="جلسات دیده شده کاربر" v-if="$route.params.id">
      <data-table
        :fields="sessionFields"
        :items="seenSessions"
        :loading="loading"
        @onRowClicked="
          $router.push({
            name: 'show-session-course',
            params: { id: $event.pivot.course_id, session_id: $event.id },
          })
        "
      >
        <template #id="{ data }">
          {{ data.item.id }}
        </template>

        <template #name="{ data }"
          ><div style="white-space: nowrap">{{ data.item.name }}</div></template
        >
        <template #course="{ data }"
          ><div style="white-space: nowrap">
            دوره : {{ data.item.pivot.course_id }}
          </div></template
        >
        <template #seen_at="{ data }">
          <b-badge>
            {{ calcDate(data.item.pivot.seen_at) || "-" }}
          </b-badge></template
        >
        <template #status="{ data }">
          <b-badge
            :variant="data.item.active ? 'light-success' : 'light-danger'"
            >{{ data.item.active ? "فعال" : "غیر فعال" }}
          </b-badge>
        </template>
        <template #actions="{ data }">
          <b-button
            size="sm"
            variant="flat-primary"
            :to="{
              name: 'show-session-course',
              params: {
                id: data.item.pivot.course_id,
                session_id: data.item.id,
              },
            }"
          >
            <feather-icon icon="EyeIcon" />
            <span class="ml-50">مشاهده</span>
          </b-button>
        </template>
      </data-table>
    </b-card>
    <b-card>
      <data-table :fields="fields" :items="auditLogs" :loading="loading">
        <template #id="{ data }">
          {{ data.item.id }}
        </template>
        <template #user="{ data }">
          {{ data.item.user.first_name + " " + data.item.user.last_name }}
        </template>
        <template #auditable_type="{ data }">
          {{ convertLogs(data.item.auditable_type) }}
        </template>
        <template #old_values="{ data }">
          <div v-if="Object.keys(data.item.old_values).length" class="c-table">
            <div
              v-for="(val, key, index) in data.item.old_values"
              :key="index"
              class="my-50"
            >
              <span style="white-space: nowrap" v-if="key != 'response'">{{
                convertLogs(key, val)
              }}</span>
              <template v-else>
                <span>جواب :</span>
                <span v-html="val"></span>
              </template>
            </div>
          </div>
          <div v-else>-</div>
        </template>
        <template #new_values="{ data }">
          <div v-if="Object.keys(data.item.new_values).length" class="c-table">
            <div
              v-for="(val, key, index) in data.item.new_values"
              :key="index"
              class="my-50"
            >
              <span style="white-space: nowrap" v-if="key != 'response'">{{
                convertLogs(key, val)
              }}</span>
              <template v-else>
                <span>جواب :</span>
                <span v-html="val"></span>
              </template>
            </div>
          </div>
          <div v-else>-</div>
        </template>
        <template #event="{ data }">
          {{ convertLogs(data.item.event) || "-" }}
        </template>
        <template #created_at="{ data }">
          {{ calcDate(data.item.created_at) || "-" }}
        </template>
        <template #Ip="{ data }">
          {{ data.item.ip_address || "-" }}
        </template>
      </data-table>
      <div
        class="w-100 d-flex flex-wrap justify-content-between align-items-center"
      >
        <div
          class="col-md-6 ml-auto d-flex justify-content-md-center align-items-center"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="pagination.total"
            :per-page="pagination.per_page"
            size="md"
            class="my-2 d-flex justify-content-center"
          ></b-pagination>
        </div>
        <b-form
          @submit.prevent="goTo"
          class="d-flex col-md-3 align-items-center justify-content-md-end pr-0"
        >
          <div>
            <b-button type="submit" size="sm" variant="primary"
              >رفتن به
            </b-button>
          </div>
          <b-form-group label-for="to-page" class="w-50 ml-50 mb-0">
            <b-form-input
              id="to-page"
              type="number"
              size="sm"
              :max="pagination.total_pages"
              min="1"
              v-model="choosenPage"
            />
          </b-form-group>
        </b-form>
      </div>
    </b-card>
    <last-comments />
    <last-penalties />
    <last-invoices />
  </div>
</template>
<script>
import {
  BButton,
  BBadge,
  BPagination,
  BLink,
  BCard,
  BAvatar,
  BFormInput,
  BForm,
  BFormGroup,
} from "bootstrap-vue";
import DataTable from "@/@core/components/data-table/DataTable.vue";
import qs from "qs";
import auditLogs from "@/views/pages/audit-logs/auditKeys";
import lastComments from "@/views/pages/dashboard/lastComments.vue";
import lastPenalties from "@/views/pages/dashboard/lastPenalties.vue";
import lastInvoices from "@/views/pages/dashboard/lastInvoices.vue";
import coursesProgress from "./coursesProgress.vue";

export default {
  components: {
    DataTable,
    BButton,
    BCard,
    BBadge,
    BPagination,
    BLink,
    BAvatar,
    BFormInput,
    BForm,
    BFormGroup,
    lastComments,
    lastPenalties,
    lastInvoices,
    coursesProgress,
  },
  props: {
    seenSessions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      auditLogs: [],
      search: "",
      loading: false,
      choosenPage: 1,
      url: "/panel/audits",
      currentPage: 1,
      pagination: {},
      visible: false,
      loader: false,

      sessionFields: [
        { key: "id", label: "شناسه" },
        { key: "name", label: "نام" },
        { key: "course", label: "مربوط به" },
        { key: "seen_at", label: "زمان مشاهده جلسه" },
        { key: "status", label: "وضعیت" },
        { key: "actions", label: "عملیات" },
      ],
      fields: [
        { key: "id", label: "شناسه" },
        { key: "user", label: "نام کاربر" },
        { key: "auditable_type", label: "مدل" },
        { key: "old_values", label: "مقدار قبلی" },
        { key: "new_values", label: "مقدار جدید" },
        { key: "event", label: "عملیات" },
        { key: "created_at", label: "تاریخ" },
        { key: "Ip", label: "Ip" },
      ],
      params: {
        per_page: 8,
        page: 1,
        filters: {
          user_id: this.$route.params.id,
        },
      },
    };
  },
  watch: {
    $route: {
      handler(val) {
        this.getAuditLogs();
      },
      immediate: true,
      deep: true,
    },
    currentPage(val) {
      this.choosenPage = val;
      if (val != this.$route.query.page) {
        this.$router.push({
          name: this.$route.params.id
            ? "user-audit-logs"
            : "profile-audit-logs",
          query: {
            ...this.$route.query,
            page: val,
          },
        });
      }
    },

    search(val) {
      if (!val && this.$route.query.key) {
        this.$router.push({
          name: this.$route.params.id
            ? "user-audit-logs"
            : "profile-audit-logs",
        });
      }
    },
  },

  methods: {
    goTo() {
      this.currentPage = this.choosenPage;
    },
    convertLogs(key, val) {
      return val != null
        ? auditLogs[key] +
            " : " +
            (val == 1 && key == "status"
              ? "فعال"
              : val == 0 && key == "status"
              ? "غیر فعال"
              : val == 1 && key == "gender"
              ? "مرد"
              : val == 0 && key == "gender"
              ? "زن"
              : val == 1
              ? "بله"
              : val == 0
              ? "خیر"
              : key.includes("_at")
              ? this.calcDate(val)
              : val)
        : auditLogs[key];
    },
    async onSearch() {
      if (this.search) {
        this.$router.push({
          name: this.$route.params.id
            ? "user-audit-logs"
            : "profile-audit-logs",
          query: {
            key: this.search,
          },
        });
      }
    },

    async getAuditLogs() {
      this.loading = true;
      try {
        const params = {
          per_page: 8,
          ...this.$route.query,
          includes: ["user", "auditable"],
        };
        if (this.$route.params.id) {
          params.filters = {
            user_id: this.$route.params.id,
          };
        }
        const { data } = await this.$http.get(this.url, {
          params,
          paramsSerializer: (params) => {
            return qs.stringify(params);
          },
        });
        this.auditLogs = data.data.audits;
        this.pagination = data.data.meta.pagination;
        this.currentPage = await this.pagination.current_page;
      } catch (err) {}
      this.loading = false;
    },
  },
};
</script>
<style scoped lang="scss">
.c-table {
  /* width */
  &::-webkit-scrollbar {
    width: 4px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #e2e2e2;
    border-radius: 10px;
  }
}
</style>
